module.exports = __webpack_public_path__ + "media/images/TaslerIT_Logo_vert_blk-f490b158be6b6edd5f73eb7f9040c425.svg";